// extracted by mini-css-extract-plugin
export default {"messageForm":"index_messageForm__LvxZk"};